<app-widget [widget-meta]="this.data"
  alertCount="{{(myRequests$ | async)?.count}}"
  class="widget-transfer-credits"
  showHelp="true">
  @if (myRequests$ | async; as studentview) {
    <div>
      <ng-container>
        <div class="card">
          <div class="card-header card-header-tabs mb-0 pb-0 mx-0 pe-0 ps-1">
            <ul class="nav nav-tabs">
              @if (profile.settings.transferCreditsShowNewApprovalList) {
                <li>
                  <a class="nav-link" [ngClass]="{ 'active show': currentTab == 'instructions' }" href="#instructions" role="tab" data-bs-toggle="tab"
                  aria-controls="instructions" aria-selected="true" (click)="currentTab='instructions'">Instructions</a>
                </li>
              }
              @if (!!studentview.count) {
                <li class="nav-item ng-star-inserted">
                  <a class="nav-link" [ngClass]="{ 'active show': currentTab == 'myRequests' }" href="#myrequest" role="tab" data-bs-toggle="tab" aria-controls="myrequest" aria-selected="true"
                  (click)="clearNewRequest(); currentTab='myRequests'">My Requests</a>
                </li>
              }
              <!--  When the app update goes live the students will either have the old form or the new form for submitting, they will not have both  -->
              @if (!profile.settings?.transferCreditsShowNewApprovalList) {
                <li class="nav-item ng-star-inserted">
                  <a class="nav-link" [ngClass]="{ 'active show': currentTab == 'newRequest'}" href="#newrequest" role="tab" data-bs-toggle="tab" aria-controls="newrequest"
                  aria-selected="true" (click)="currentTab='newRequest'">New Request</a>
                </li>
              }
              @if (profile.settings.transferCreditsShowNewApprovalList) {
                <li class="nav-item ng-star-inserted">
                  <a class="nav-link" [ngClass]="{ 'active show': currentTab == 'courses'}" href="#courses" role="tab" data-bs-toggle="tab" aria-controls="courses"
                  aria-selected="true" (click)="currentTab='courses'">Pre-Approved Courses</a>
                </li>
                @if (showDraft) {
                  <li class="nav-item ng-star-inserted">
                    <div class="nav-link d-flex align-items-center" [ngClass]="{ 'active show': currentTab == 'draftRequest'}">
                      <a href="#draftRequest" role="tab" data-bs-toggle="tab" aria-controls="draftRequest"
                        aria-selected="true" (click)="currentTab='draftRequest'">
                        Draft Request
                      </a>
                      <button type="button"
                        class="btn btn-sm btn-close ms-2"
                        aria-label="Close"
                        tabindex="-1"
                        (click)="closeDraftRequestTab()">
                      </button>
                    </div>
                  </li>
                }
              }
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content mt-3">
              <!--  INSTRUCTIONS -->
              @if (currentTab =='instructions') {
                <div class="tab-pane fade"
                  [ngClass]="{ 'active show':  currentTab == 'instructions' }" id="instructions" role="tabpanel" aria-labelledby="instructions">
                  <div>PLEASE REVIEW BEFORE  FOR USE:</div>
                  <ul>
                    <li>
                      MyKE Global Credit Database is your go-to resource to search courses you could potentially take while abroad AND where you will submit course approval requests while you are abroad. It
                      is ONLY for Kenan-Flagler Global Programs - if you are studying through the Study Abroad Office, do not use this resource.
                    </li>
                    <li>
                      Use the ‘Pre-Approved Courses’ tab to view courses that have been Pre-Approved for credit at our various partner universities. The optional filters shown can be utilized to narrow by
                      program, UNC Department for credit, core course, AOE, Gen Ed, or country. You can then save courses you are interested in taking as drafts in your ‘My Requests’ tab.
                    </li>
                    <li>
                      View our ‘<a href="https://www.kenan-flagler.unc.edu/programs/undergraduate-business/global-programs/academic-procedures/" target="_blank">Global Programs Academic Procedures</a>’ page
                      & the ‘Academics’ tab on each program page on our <a href="https://www.kenan-flagler.unc.edu/programs/undergraduate-business/global-programs/" target="_blank">website</a> for more information
                      related to academic policies and procedures governing abroad programs.
                    </li>
                    <li>
                      MyKE is a great place to start your research into potential course options, however:
                      <ul>
                        <li>
                          You should NOT submit courses for review UNTIL you have been accepted & enrolled into a Kenan-Flagler Global Program!  You are able to save ‘draft’ courses in your ‘My Requests’
                          tab while you research program options but the UBP Global Programs team WILL NOT review or approve courses for students that have not enrolled in a program.
                        </li>
                        <li>
                          Once you have enrolled in a program, you may submit courses officially, and can submit your draft courses from your ‘My Requests’ tab. After being enrolled in your program, team
                          will provide more instructions on how to submit courses.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div>IMPORTANT DISCLAIMERS:</div>
                  <ul>
                    <li>
                      MyKE Global Transfer Credits is a useful tool to search for pre-approved courses. However, please note that just because a course has been pre-approved, <strong>it does NOT guarantee
                      the course will be offered the term (e.g. semester or summer) you study abroad.  <span class="text-decoration-underline">Just like at UNC, course offerings can change year over year, and
                    semester over semester!</span></strong> Additionally, we can’t guarantee that you will get into the course, even if it is offered at your host university the term you are abroad.
                  </li>
                  <li>
                    We partner with business schools to ensure you can get valuable business credit while abroad, but we <strong> do not guarantee specific business core credit, or specific business elective
                  credit during your time abroad, or specific credit for your second major/minor.</strong>
                </li>
                <li>
                  The Pre-Approved Courses List is  NOT an exhaustive list of available courses or programs. The database will update as new courses are reviewed and approved, with new courses being added
                  all the time.
                </li>
              </ul>
              <div>If you have questions on credit transfer, email us at <a href="mailto:ubpglobal@kenan-flagler.unc.edu">ubpglobal&#64;kenan-flagler.unc.edu</a></div>
            </div>
          }
          <!--  MY REQUESTS  -->
          @if (currentTab =='myRequests') {
            <div class="tab-pane fade"
              [ngClass]="{ 'active show':  currentTab =='myRequests' }" id="myrequest" role="tabpanel" aria-labelledby="myrequest">
              @if (!!studentview?.requests?.MoreInfo?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'MoreInfo', nextStates: ['Draft', 'Pending', 'Review', 'Approved', 'Denied'] }">
                </ng-container>
              }
              @if (!!studentview?.requests?.Draft?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'Draft', nextStates: ['Pending', 'Review', 'Approved', 'Denied']}">
                </ng-container>
              }
              @if (!!studentview?.requests?.Pending?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'Pending', nextStates: ['Review', 'Approved', 'Denied']}">
                </ng-container>
              }
              @if (!!studentview?.requests?.Review?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'Review', nextStates: ['Approved', 'Denied']}">
                </ng-container>
              }
              @if (!!studentview.requests?.Approved?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'Approved', nextStates: []}">
                </ng-container>
              }
              @if (!!studentview?.requests?.Denied?.length) {
                <ng-container [ngTemplateOutlet]="requestTemplate"
                  [ngTemplateOutletContext]="{ requests:studentview.requests, currentState:'Approved', nextStates: []}">
                </ng-container>
              }
            </div>
          }
          <!--  NEW REQUEST  -->
          @if (currentTab =='newRequest') {
            <div class="tab-pane fade"
              [ngClass]="{ 'active show': currentTab =='newRequest'}" id="newrequest" role="tabpanel" aria-labelledby="newrequest">
              <div class="d-flex flex-row-reverse" style="height: 1em">
                @if (transferCredits.saveStatus$ | async; as saveText) {
                  <sub [ngClass]="{'text-success':!!!transferCredits.hasSaveError,'text-danger':!!transferCredits.hasSaveError}">
                    <i class="far fa-save"></i>&nbsp;{{saveText}}
                  </sub>
                }
              </div>
              <app-credit-request></app-credit-request>
            </div>
          }
          <!--  PRE-APPROVED COURSES  -->
          @if (currentTab =='courses') {
            <div class="tab-pane fade" id="courses" role="tabpanel" [ngClass]="{ 'active show': currentTab =='courses' }" aria-labelledby="courses">
              <app-approval-new-request-list (editRequest)="onEditRequest($event)"></app-approval-new-request-list>
            </div>
          }
          <!--  DRAFT REQUEST  -->
          @if (currentTab =='draftRequest') {
            <div class="tab-pane fade" id="draftRequest" role="tabpanel" [ngClass]="{ 'active show': currentTab =='draftRequest' }" aria-labelledby="draftRequest">
              <app-approval-edit-request [courseId]="selectedCourseId" (close)="closeDraftRequestTab($event)"></app-approval-edit-request>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-container>
</div>
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}

<ng-template #requestTemplate let-requests='requests' let-currentState='currentState' let-nextStates='nextStates'>
  @if (!!requests[currentState]?.length) {
    @if (currentState == 'Draft') {
      <div class="d-flex justify-content-end">
        @if (bulkDraftResponse$ | async) {
        }
        <button type="button" class="btn btn-sm btn-success" (click)="submitDrafts$.next()">Submit All Drafts</button>
      </div>
    }
    @for (request of requests[currentState]; track request.Id) {
      <div class="pt-2">
        <div class="row col-12 mb-3">
          <div class="col-12" [ngClass]="{'col-lg-3 col-xl-2': this.data.Size == '12'}">
            <span>
              @if (request.Status == 'More Info') {
                <span class="tile tile-circle status-more-info">
                  <i class="far fa-clipboard-list"></i>
                </span>
              }
              @if (request.Status == 'Draft') {
                <span class="tile tile-circle status-draft">
                  <i class="far fa-file-edit"></i>
                </span>
              }
              @if (request.Status == 'Pending') {
                <span class="tile tile-circle status-pending">
                  <i class="far fa-clock"></i>
                </span>
              }
              @if (request.Status == 'Review') {
                <span class="tile tile-circle status-under-review">
                  <i class="fas fa-tasks"></i>
                </span>
              }
              @if (request.Status == 'Approved') {
                <span class="tile tile-circle  status-approved">
                  <i class="far fa-check-circle"></i>
                </span>
              }
              @if (request.Status == 'Denied') {
                <span class="tile tile-circle bg-red status-denied">
                  <i class="far fa-times-circle"></i>
                </span>
              }
              <span class="ms-1">{{request.Status}}</span>
            </span>
          </div>
          <div class="col-12" [ngClass]="{'col-lg-4 col-xl-5': this.data.Size == '12'}">
            @if (!!request.HostCourseName) {
              <small>{{request.HostCourseName}}</small>
            }
            @if (!!request.HostCourseNumber) {
              <small> ({{request.HostCourseNumber}})</small>
            }
            @if ((!!request.HostCourseName || !!request.HostCourseNumber) && !!request.HostCreditHours) {
              <span>, </span>
            }
            @if (!!request.HostCreditHours) {
              <small>{{request.HostCreditHours}} credits</small>
            }
            @if (!!request.HostCourseName || !!request.HostCourseNumber || !!request.HostCourseNumber || !!request.HostCreditHours) {
              <small><br /></small>
            }
            @if (!!request.Term) {
              <small>{{request.Term}} </small>
            }
            @if (!!request.HostUniversityDisplay) {
              <small>{{request.HostUniversityDisplay}}</small>
            }
          </div>
          <div class="col-12" [ngClass]="{'col-lg-3': this.data.Size == '12'}">
            @if (!!request.UncCourse) {
              <small>for {{request.UncCourse}}</small>
            }
            @if (!!request.UncCourse && !!request.UncCourseHours) {
              <span>,</span>
            }
            @if (!!request.UncCourseHours) {
              <small> {{request.UncCourseHours}} credits</small>
            }
            @if (!!request.UncCourse || !!request.UncCourseHours) {
              <small><br /></small>
            }
            @if ((request.HostCourseNumber=='0') && request.HostCourseName.toLowerCase().includes('extra hours')) {
              <small><i class="fal fa-user-cog"></i> - Added by admin <br /></small>
            }
            @if (request.Status == 'Draft') {
              <small>Created - {{request.Created?.TimeStamp | date: 'shortDate'}} <br /></small>
            }
          </div>
          <div class="col-12 no-gutters" [ngClass]="{'col-lg-2': this.data.Size == '12'}">
            @if (request.Status == 'Draft') {
              <button type="button" [disabled]="isDeleteDraftRequestRunning[request.Id]" class="btn btn-danger btn-min-size btn-margins" [ngClass]="{'mr-1': this.data.Size == '12', 'mb-1 mr-1': this.data.Size != '12'}" (click)="deleteDraft(request.Id, request)">Delete  @if (isDeleteDraftRequestRunning[request.Id]) {
                <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
              }</button>
            }
            @if ((request.Status == 'Draft') || (request.Status == 'More Info')) {
              <button type="button" class="btn btn-primary btn-min-size btn-margins" [ngClass]="{'mb-1': this.data.Size != '12'}" (click)="updateRequest(request)">Update</button>
            }
          </div>
        </div>
        @if ((request.Status == 'More Info') || (request.Status=='Denied')) {
          <div class="row col-12">
            @if (!!request.RecentNote) {
              <div class="col-12" [ngClass]="{'col-lg-7 offset-lg-3 col-xl-8 offset-xl-2': this.data.Size == '12'}">
                <small class="fw-bold">{{request.RecentNote}}</small>
              </div>
            }
          </div>
        }
      </div>
    }
  }

  @if (requests | hasAny: nextStates) {
    <hr />
  }
</ng-template>


</app-widget>
